import React from "react";
import QuestionTextInput from "@/components/page/QuestionTextInput";
import QuestionRadioInput from "@/components/page/QuestionRadioInput";
import parse from "html-react-parser";

export default function QuestionBlock(props) {

    const complete = Boolean(props.complete || props.answer);

    let feedback = null;
    if (complete) {
        feedback = props.item.data.options?.find(option => parseInt(option.id) === parseInt(props.answer));
    }

    return (
        <div>

            <div className="text-base font-semibold leading-6 text-gray-900">{  props.item.data.question  }</div>

            <div className="mt-4">
                {
                    (() => {

                        console.log("QuestionBlock props");
                        console.log(props);

                        console.log("complete?", complete);

                        switch (props.item.data.type) {
                            case 'textarea':
                                return <QuestionTextInput name={"answer_"+props.item.data.id} value={props.answer} disabled={(props.complete || props.answer)} onChange={props.onChange}/>
                            default:
                                return <QuestionRadioInput data={props.item.data} value={props.answer} disabled={(props.complete || props.answer)} onChange={props.onChange}/>
                        }

                    })()

                }

                {complete && feedback?.advanced?.feedback &&
                    <div className="my-2">
                        { parse(feedback?.advanced?.feedback) }
                    </div>
                }
            </div>

        </div>
    )
}